module.exports = __webpack_public_path__ + "public/1.0.1_896977/img/pdf.0999dcf6.svg";